import { render, staticRenderFns } from "./perfect.vue?vue&type=template&id=faa5744c&scoped=true"
import script from "./perfect.vue?vue&type=script&lang=js"
export * from "./perfect.vue?vue&type=script&lang=js"
import style0 from "./perfect.vue?vue&type=style&index=0&id=faa5744c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa5744c",
  null
  
)

export default component.exports